import { BridgeFiatRail } from 'services/merchants/types';

import { CurrencyCode } from 'types/currency';

export enum PayoutType {
  Crypto = 'crypto',
  Fiat = 'fiat',
}

export interface Payout {
  type: PayoutType;
}

export interface FiatPayout extends Payout {
  currency: CurrencyCode;
  paymentRail: BridgeFiatRail;
}
